import React from "react";
import img from "../../assets/bg2.JPG";
import { Container, Nav, Navbar } from "react-bootstrap";
import "aos/dist/aos.css"; // Import AOS animations
import { Link } from "react-scroll"; // Use Link from react-scroll

import AOS from "aos";
import "./Hero.css"; // Import custom styles

function Hero() {
  React.useEffect(() => {
    AOS.init({ duration: 1200, easing: "ease-in-out", once: false });
  }, []);

  return (
    <div className="hero-container">
      <div className="hero-content">
        <div className="text-section">
          <h1 data-aos="fade-right">
            Let's Work Together to Create Something Amazing!
          </h1>
          <p data-aos="fade-right">
            A visionary creative, creating captivating wonders <br />
            <span>through art and design.</span>
          </p>
          <p data-aos="fade-right">
            Adept at turning <span>imagination</span> into <br />
            <span>extraordinary reality</span>.
          </p>
          <div className="button-group" data-aos="fade-up">
            <Nav.Link
              as={Link}
              to="contact"
              smooth
              duration={500}
              className="nav-link-custom fs-5"
            >
              <button className="hero-button">Hire Me</button>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="project"
              smooth
              duration={500}
              className="nav-link-custom fs-5"
            >
              <button className="hero-button hero-button-secondary">
                Projects
              </button>{" "}
            </Nav.Link>
          </div>
        </div>
        <div className="image-section" data-aos="zoom-in">
          <img src={img} alt="Creative" />
        </div>
      </div>
      <div className="metrics-section">
        <div className="metric" data-aos="fade-up">
          <h1>2+</h1>
          <p>Years of Experience</p>
        </div>
        <div className="metric" data-aos="fade-up">
          <h1>4</h1>
          <p>Projects</p>
        </div>
        <div className="metric" data-aos="fade-up">
          <h1>80%</h1>
          <p>Satisfied Clients</p>
        </div>
      </div>
    </div>
  );
}

export default Hero;
